// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Activities_wrapper__1Azsv","info":"Activities_info__2m4ul"};